export default {
    id: 2,
    rank: 2,
    name: "Codere",
    bonoEuros: 200,
    bonoCasino: 200,
    reviewUrl: "/bono_codere",
    bonoUrl: "https://m.apuestas.codere.es/deportes/index.htm#/PromotionsPage",
    bonoCasinoUrl: "https://m.apuestas.codere.es/deportes/index.htm/PromotionsPage",
    rating: 4.3,
    metaTitle: "Codere: Opinión y Análisis 2020 | Obtén 15€ o 20€ Gratis",
    metaDescription: "Análisis y opinión franca de Codere. La guía más completa para que todo apostante pueda sacar el máximo partido a su dinero y tiempo. ",
    imageUrl: "CodereGrey.png",
    intoduction: `<p class="opinion-p-space">
    Codere es uno de los operadores de juegos y apuestas mas importantes en España. <br />
    <br />
    La casa de apuesta oficial del Real Madrid fue fundada en 1980 y en sus inicios se centró en la fabricación y
    operación de máquinas recreativas para la comunidad de Madrid.<br />
    <br />
    Tres años más tarde, en 1983, comienza a expandirse a Catalunya, Valencia y resto de España posteriormente. En la
    actualidad Codere tiene presencia en más de 8 países, algunos de ellos son, Argentina, Brasil, Uruguay, Colombia,
    México, Panamá, Italia y en toda la geográfica española. <br />
    <br />
    Codere actualmente cuenta con más de 2.000 salas de juego en toda España, y con una página de apuesta deportiva y
    juegos en línea que amasa miles de usuarios. <br />
    <br />
    Las operaciones de juego online en España comienzan en el 2014 con su ambicioso portal web de apuesta deportiva y
    casino. En donde los usuarios registrados pueden apostar a multitud de deportes, aunque el deporte destacado como no
    puede ser otro en un portal de apuesta deportiva español es el futbol. <br />
    <br />
    Las claves del éxito de esta casa de apuestas online son, una política de bonos de bienvenida para nuevos usuarios
    bastante solida y un servicio al cliente de alta calidad.<br />
    <br />
    Te animo a seguir leyendo si buscas conocer en detalle lo bueno y lo malo de Codere. <br />
    <br />
    Si por el contrario ya has leído suficiente y te has animado a probar suerte, pincha en alguno de los siguientes
    enlaces para obtener tu bono de <a href="https://m.apuestas.codere.es/deportes/index.htm/PromotionsPage"
        target="#blank">200€ en freebets para apuesta deportiva</a> o bien un bono 
        <a href="https://m.apuestas.codere.es/deportes/index.htm/PromotionsPage" target="#blank">100% de tu primer 
        deposito para casino.</a>
</p>`,
    prosandCons: [
        {
            type: "pro",
            comment: "Cobertura extensa para apuestas deportivas"
        }, {
            type: "pro",
            comment: "Posibilidad de ingresos y cobros presenciales "
        }, {
            type: "pro",
            comment: "Supercuotas disponibles"
        }, {
            type: "pro",
            comment: "Bono de bienvenida fácil de liberar"
        }, {
            type: "con",
            comment: "Catálogo de casino moderado"
        },
        {
            type: "con",
            comment: "No hay bingo"
        }
    ],
    deposit: ["visa", "mastercard", "paysafe", "banktransfer", "skrill", "neteller", "paypal"],
    withdraw: ["banktransfer", "paypal"],
    contact: {
        phoneNumber: "900 10 45 54",
        email: "apuestas@codere.com",
        chat: true
    },
    opinion: `<div id="co-main-section" class="title-text opinion-card-title opinion-title-space linkable-section">
    Variedad y Tipos de Apuestas
</div>
<p class="opinion-p-space">
    La oferta de esta casa de apuestas esta muy bien adaptada al mercado español. La profundidad en el mercado
    futbolístico es excelente y la diversidad en otras disciplinas es buena. <br />
    <br />
    Codere casino cuenta con un catálogo limitado en comparación de otros casinos online, aun así podrás jugar a
    múltiples tragaperras, la ruleta, el blackjack y el póker.
</p>
<div class="opinion-card-subtitle">
    Apuesta deportiva
</div>
<p class="opinion-p-space">
    Si te gusta el deporte, es posible que te quedes un buen rato apostando en este portal a eventos y partidos de todos
    los continentes.<br />
    <br />
    <div class="opiniones-img">
        <img src="assets/images/co_deportes.png" />
    </div>
    Codere no decepciona en cuanto a variedad, sobre todo cuando viene al futbol. Aquí podrás apostar a una gran
    variedad de eventos, copas, ligas y divisiones. Las más conocidas son la Bundesliga, La Serie A, Premier League,
    League One, La Liga y más. También encontrarás ligas regionales como, por ejemplo, la de Chipre, la de Las Islas
    Feroe o la de Catar.<br />
    <br />
    Los deportes que agrupan el mayor número de apuestas son el futbol, el tenis y el baloncesto, pero el catálogo
    deportivo es muy extenso. Encontraras un total de 30 modalidades deportivas disponibles entre las cuales tienes los
    dardos, el snooker, hockey sobre hielo, golf, rugby, motor, vóley playa, e-sports y más.<br />
    <br />
    Para baloncesto tendrás a tu disposición apuestas deportivas para las principales competiciones como la NBA, NBL,
    Euroliga, Liga ABC, NBL de Bulgaria, Liga de Argentina, Liga Francesa, y muchas otras. Para el tenis el US Open
    individual masculino y femenino, ATP de Amberes, WTA Ostrava, Winbledon, Open de Australia, etc.<br />
    <br />
    Tampoco podemos dejar de mencionar <strong>las apuestas en directo.</strong> Aquí la lista de deportes es algo
    modesta, pero dispones
    de Codere TV, un servicio de video en vivo para usuarios registrados. Entre los deportes en vivo encontramos el
    baloncesto, el voleibol, el tenis de mesa, el futbol sala, los eSports y por supuesto, el deporte rey en Codere, el
    futbol.<br />
    <br />
    Para hacer tu boleta de apuestas podrás elegir entre apuestas simples, combinadas, múltiples, en vivo o
    pre-partido.<br />
    <br />
    Existe también la funcionalidad de <strong>cashout</strong> con la que puedes elegir cerrar tu apuesta en cualquier
    momento del
    partido e irte con las ganancias conseguidas hasta ese instante. Codere irá incrementando la cantidad de dinero a
    devolver en función del tiempo que queda para finalizar el partido.<br />
    <br />
    El <strong>importe mínimo de una apuesta</strong> variará según el tipo de apuesta. Si es una apuesta sencilla el
    importe tendrá un
    mínimo de 1€ por apuesta. En el caso que sea una apuesta múltiple o combinada el importe mínimo será de 0,20 €.
</p>

<div class="opinion-card-subtitle">
    Codere Casino
</div>
<p class="opinion-p-space">
    Aunque la casa Codere es principalmente conocida como una casa de apuesta deportiva, su web de casino está bastante
    bien.<br />
    <br />
    La selección de slots y juegos de casino no es demasiado extensa, pero es de primer nivel en cuanto a calidad y
    diseño. Y es que Codere ha sabido elegir a los mejores desarrolladores de software de la industria (NetEnt,
    Playtech, MGA iSoftBet, Habanero y Evolution Gaming) para componer su portal.<br />
    <br />
    Un detalle que, en mi opinión, es la ventaja de Codere casino sobre otros casinos online es que cuenta con los
    megabotes progresivos o Jackpots más grandes en el sector. Pueden llegar al medio millón de euros, o más.<br />
    <br />
    <strong>#PROtip:</strong> encuentra un resumen de los megabotes progresivos en el submenú dentro de la sección
    casino. Desde aquí
    puedes ver como van aumentado los botes de dinero acumulado a tiempo real.<br />
    <br />
<div class="opiniones-img">
    <img src="assets/images/co_masmillon.png" />
</div>
En Codere hay <strong>más de 150 máquinas tragaperras</strong> que combinan la emoción de los slots tradicionales, con
gráficos 3D e
historias inmersivas de video juegos. Algunas de las tragaperras mas populares en Codere incluyen: Slots Vikingos,
Oz Slots, Slots de faraones, la tragaperras de la isla volcánica de Java Lucky 3 y London Hunter.<br />
<br />
Antes de que juegues un slot querrás entender cómo funciona, por lo que <strong>todas las maquinas tienen una versión de
    prueba gratuita,</strong> sin necesidad si quiera de registrarse.<br />
<br />
No faltan opciones para quienes buscan los juegos de casino clásicos. En Codere encontraremos distintas modalidades
<strong>de Blackjack y de Ruleta.</strong><br />
<br />
El blackjack está disponible en sus versiones super 21, perfect, surrender, americano, lucky lucky, cashback y
tradicional. Para la ruleta tenemos ruleta en vivo además de americana, premium, europea, francesa, multiplayer,
express, quantum y quantum automática.<br />
<br />
La ruleta en vivo es toda una experiencia inmersiva en donde podrás interactuar con el crupier y los demás
jugadores.
</p>


<!-- ----------------------------------------------------------------------------------------------------------------------------------->
<div id="co-bonos-prom-section" class="title-text opinion-card-title opinion-title-space linkable-section">
    Bonos y Promociones
</div>
<div class="opinion-card-subtitle">
    Triple Bono de Bienvenida: hasta 200€ en Freebets
</div>
<div class="opiniones-img">
    <img src="assets/images/co_hasta200.png" />
</div>

<p class="opinion-p-space">
    Se trata de un bono transparente y sin demasiadas complicaciones que te devuelve el 100% de tus depósitos hasta 200€
    en freebets para su uso en apuestas deportivas.<br />
    <br />
    El bono está disponible para nuevos usuarios, y lo primero que debes hacer para liberar tu bono de bienvenida es
    registrarte correctamente a través de <a href="https://m.apuestas.codere.es/deportes/index.htm/RegistroPage"
        target="#blank">este enlace.</a> No te tomará más de unos minutos y una vez comprobados tus datos,
    podrás empezar a jugar.
</p>

<div class="opinion-card-subtitle">
    ¿Cómo desbloquear el bono?
</div>

<p class="opinion-p-space">
    Se desbloquea en 3 sencillos tramos:<br />
    <br />
    Bono 1 100% hasta 50€ <br />
    - Ingreso mínimo de 10€<br />
    - Realizar apuestas de cuota 1.5 o superior, por el valor del bono que hemos recibido<br />
    <br />
    Bono 2 100% hasta 50€ <br />
    - Haber desbloqueado el bono 1<br />
    - Ingreso mínimo de 10€<br />
    - Realizar apuestas de cuota 1.5 o superior, por el valor del bono que hemos recibido<br />
    <br />
    Bono 3 100% hasta 100€ <br />
    - Haber desbloqueado el bono 2<br />
    - Ingreso mínimo de 10€<br />
    - Realizar apuestas de cuota 1.5 o superior, por el valor del bono que hemos recibido<br />
    <br />
    Es muy importante que durante este tiempo no hagas ninguna retirada de dinero, de lo contrario tus freebets
    quedarían anuladas.<br />
    <br />
    <strong>#PROTip:</strong> para conseguir el máximo valor de bono (200€) tendrás que hacer tres ingresos en el
    siguiente orden: 50€,
    50€ y 100€ en un plazo de 60 días. <br />
    <br />
</p>

<div class="opinion-card-subtitle">
    ¿Cómo utilizar las freebets?
</div>
<p class="opinion-p-space">
    Las apuestas gratuitas (freebets) se te irán acreditando según se vayan liberando y tendrás 30 días para utilizarlas
    en apuestas de coeficiente igual o superior a 1.5. Pero no te preocupes, hay un gran número de apuestas con cuota
    1.5 que son perfectamente conseguibles.
</p>
<div class="opinion-card-subtitle">
    Bono de Bienvenida: 100% de tu 1er depósito hasta 200€
</div>

<div class="opiniones-img">
    <img src="assets/images/co_bonohasta200.png" />
</div>

<p class="opinion-p-space">
    Se trata de un bono casino que te devuelve el 100% de tus depósitos hasta 200€. Solo está disponible para nuevos
    usuarios. El primer paso en la obtención de tu bono es el de registrarte en <a
        href="https://m.apuestas.codere.es/deportes/index.htm#/RegistroPage" target="#blank">este enlace.</a>
</p>

<div class="opinion-card-subtitle">
    ¿Cómo desbloquear el bono?
</div>

<p class="opinion-p-space">
    Una vez registrado, tendrás que realizar un depósito por valor de 10€ o más y automáticamente recibirás el 100% de
    dicho depósito en formato de bono.<br />
    <br />
    Para liberar las ganancias obtenidas a partir del bono, antes tendrás que desbloquearlo. Para ello deberás apostar
    35 veces la cantidad del bono recibido durante los siguientes 15 días de su obtención; de lo contrario, tanto el
    bono como las ganancias obtenidas a partir del bono caducarán.<br />
    <br />
    Por ejemplo, si hacemos un deposito inicial de 15€, recibiremos un bono de 15€ para un total de 30€. El requisito
    para liberar las ganancias obtenidas es apostar <strong>(35 x 15 = 525€)</strong> durante los siguientes 15
    días.<br />
    <br />
    A primera vista parece costoso de obtener, pero lo cierto es que este rollover es uno de los más bajos en España.
    Hay que tener en cuenta que las máquinas tragaperras y otros juegos de azar online de Codere tienen un porcentaje de
    pago bastante alto; por lo que es probable que acabes con la misma cantidad de dinero o con más. ¡Además de la
    diversión que todo ello conlleva!<br />
    <br />
    Todos los juegos existentes en la pestaña casino contribuyen en un 100% a la liberación del bono. Con excepción de
    la ruleta y el blackjack que contribuyen en un 20%.<br />
    <br />
</p>

<div class="opinion-card-subtitle">
    Otras Promociones
</div>
<p class="opinion-p-space">
    En Codere también encontraras promociones temporales para usuarios ya registrados.<br />
    <br />
    Son ofertas que se actualizan cada semana o cada mes y las encontraras en el apartado ‘Promociones’. Solo debes
    recordar visitar la web regularmente.<br />
    <br />
    Algunos ejemplos de las promociones que están disponibles actualmente son:<br />
    <br />
    • Supercuota de 5,00 para el clásico Real Madrid – FC Barcelona<br />
    • Recupera hasta 20€ con apuestas acumuladas de futbol en caso de fallo<br />
    • 15% extra en todos tus depósitos para casino<br />
    • 5000€ en efectivo y bonos de casino. Por cada 10€ jugados ganas 1 participación en el sorteo<br />
    • 10% de Cashback los lunes para quienes jueguen a la ruleta<br />
    • Y muchas mas<br />
    <br />
    No dejes de <a href="https://m.apuestas.codere.es/deportes/index.htm#/RegistroPage" target="#blank">registrarte</a>
    y
    de consultar el apartado de promociones para ver que ofertas tienen en este momento. Para
    estar informado también puedes seguirles en su cuenta de Instagram @codereapuestas en donde comparten las
    ofertas
    actualizadas y los ganadores de los sorteos.
</p>

<div id="co-cuotas-section" class="title-text opinion-card-title opinion-title-space linkable-section">
    Cuotas
</div>
<p class="opinion-p-space">
    Como en la mayoría de las casas de apuestas deportivas, las cuotas pueden ser decimales, fraccionales o
    americanas.<br />
    <br />
    Los coeficientes de las cuotas son competitivos, pero al mismo similares a los de otras casas de apuestas y se
    manejas según la importancia y popularidad de cada deporte. En Codere tendrás cuotas sencillas, super combinadas y
    cuotas mejoradas que puedes aprovechar para ganar algo de dinero extra.<br />
    <br />
    <strong>#PROTip:</strong> encuentra las cuotas mejoradas en el menú de navegación del lado izquierdo en la sección
    de apuesta
    deportiva. Aquí encontrarás un resumen de cuotas altamente rentables que van desde los 6,50 hasta 11 o más.<br />
    <br />
    La casa Codere también nos ofrece <strong>Supercuotas.</strong> Generalmente destinadas a nuevos usuarios, aunque a
    veces pueden
    estar disponibles para usuarios ya registrados.<br />
    <br />
    Las supercuotas están causando furor en el mundo de las apuestas deportivas. Se trata de promociones exclusivas con
    cuotas de enorme valor respecto al mercado. Suelen salir solo para los partidos de mayor envergadura.<br />
    <br />
    Por ejemplo, la supercuota para el clásico Real Madrid – FC Barcelona suele ser de aproximadamente 5,00 y esta
    disponible tanto para usuarios nuevos como ya registrados. La apuesta mínima es de 2€ y también puedes pagarla en
    formato freebet.<br />
    <br />
    Solo tienes que <a href="https://m.apuestas.codere.es/deportes/index.htm#/RegistroPage"
        target="#blank">registrarte</a> y visitar el apartado ‘Promociones’ periódicamente.
</p>

<div class="opiniones-img">
    <img src="assets/images/co_cuotas.png" />
</div>

<!----------------------------------------------------------------------------------------------------------------------------------------->
<div id="co-depositos-retiros-section" class="title-text opinion-card-title opinion-title-space linkable-section">
    Depósitos, Retiros y Métodos de Pago
</div>
<p class="opinion-p-space">
    Una de las ventajas de Codere es que te permite depositar y retirar dinero tanto online como en cualquier local
    físico de Codere. Recuerda que tienen mas de 2000 locales en toda España, seguramente haya alguno cerca de ti.<br />
    <br />
    En resumen, los métodos de pago aceptados son los siguientes:<br />
    <br />
    <div class="info-grid-4">
        <div class="info-grid-4-header">Método de pago </div>
        <div class="info-grid-4-header">Ingreso Mínimo</div>
        <div class="info-grid-4-header">Comisión</div>
        <div class="info-grid-4-header">Tiempo de proceso</div>
        <div>En local Codere</div>
        <div>Ninguno</div>
        <div>Ninguna</div>
        <div>Inmediato</div>
        <div>Visa</div>
        <div>10€</div>
        <div>Ninguna</div>
        <div>Inmediato</div>
        <div>Mastercard</div>
        <div>10€</div>
        <div>Ninguna</div>
        <div>Inmediato</div>
        <div>PayPal</div>
        <div>15€</div>
        <div>Ninguna</div>
        <div>Inmediato</div>
        <div>Skrill</div>
        <div>15€</div>
        <div>Ninguna</div>
        <div>Inmediato</div>
        <div>Neteller</div>
        <div>15€</div>
        <div>Ninguna</div>
        <div>Inmediato</div>
        <div>Paysafecard</div>
        <div>10€</div>
        <div>Ninguna</div>
        <div>Inmediato</div>
        <div>Transferencia bancaria</div>
        <div>Ninguno</div>
        <div>Ninguna</div>
        <div>1-3 días hábiles</div>
    </div>
    <br />
    <br />
    En cuanto a los cobros, pueden realizarse mediante transferencia bancaria, Hal – Cash, PayPal o presencialmente en
    cualquier local de Codere.<br />
    <br />
    <div class="info-grid-4">
        <div class="info-grid-4-header">Método de pago </div>
        <div class="info-grid-4-header">Retiro  Mínimo</div>
        <div class="info-grid-4-header">Comisión</div>
        <div class="info-grid-4-header">Tiempo de proceso</div>
        <div>En local Codere</div>
        <div>20€</div>
        <div>Ninguna</div>
        <div>Inmediato</div>
        <div>Hal-Cash</div>
        <div>40€</div>
        <div>Ninguna</div>
        <div>Inmediato</div>
        <div>PayPal</div>
        <div>25€</div>
        <div>Ninguna</div>
        <div>8 horas max</div>        
        <div>Transferencia bancaria</div>
        <div>20€</div>
        <div>Ninguna</div>
        <div>1-3 días hábiles</div>
    </div>
    <br />
    <br />
    Para poder realizar un retiro en un local físico, antes deberás descargar a la app de Codere ya que necesitarás
    generar un código QR para mostrar al dependiente.
</p>

<!----------------------------------------------------------------------------------------------------------------------------------------->
<div id="co-seguridad-fiabilidad-section" class="title-text opinion-card-title opinion-title-space linkable-section">
    Seguridad y Fiabilidad
</div>
<p class="opinion-p-space">
    Codere es una casa de apuestas 100% fiable.<br />
    <br />
    La casa de apuestas cumple con todas las garantías de seguridad como bien lo demuestran sus licencias de la DGOJ.
    Dichas licencias no solo abarcan las apuestas deportivas y casino online, sino a su amplia red de locales de
    apuestas y juego.<br />
    <br />
    En Codere la seguridad siempre ha sido un aspecto que la empresa se ha esmerado en cuidar. La información personal
    de cada usuario está protegida bajo un sistema de encriptado, de esta forma, la casa puede asegurar tu información
    ante terceros y disminuir el riesgo en caso de hackeos.<br />
    <br />
    Todos y cada uno de los métodos de pago utilizados en Codere son 100% seguros, por lo que no debe haber ningún miedo
    a que tus datos de pago queden comprometidos.<br />
    <br />
    El juego responsable es la mejor manera de disfrutar de la gama de apuestas deportivas y juego online de Codere. La
    casa ofrece una serie de herramientas para que establezcas tus limites de juego diario, semanal o mensual.<br />
    <br />
</p>
<!----------------------------------------------------------------------------------------------------------------------------------------->
<div id="co-ui-ux-section" class="title-text opinion-card-title opinion-title-space linkable-section">
    Interfaz y Experiencia de Usuario
</div>
<p class="opinion-p-space">
    La web de Codere es clara y fácil de navegar. Se encuentra dividida 6 grandes grupos: deportes, en vivo, slots,
    casino, promociones y locales.
<div class="opiniones-img">
    <img src="assets/images/co_interfaz.png" />
</div>
En la sección deportiva, cuentan con un buscador de partidos en la esquina superior derecha que es bastante bueno si
no queremos navegar hasta él. De todas maneras, la navegación es sencilla y se encuentra del lado izquierdo de la
pantalla.<br />
<br />
Dicha estructura es la mas utilizada por casi todas las webs de apuestas, por lo que te será fácil adaptarte a ella
aun si eres nuevo.<br />
<br />
Codere también tiene una <strong>app</strong> que está disponible para móvil y tablet tanto en iOS como en
Android.<br />
<br />
La aplicación es una herramienta maravillosa, especialmente si te gusta apostar en vivo. Tiene unos tiempos de carga
veloces, casi a tiempo real. Esto viene genial para las apuestas en directo.<br />
<br />
La aplicación y la web están sincronizadas mediante tu cuenta de jugador, por lo que tendrás acceso a todas tus
apuestas, marcadores y preferencias desde ambas. También mencionar que la app es necesaria para poder realizar
ingresos y retiradas de dinero en los locales Codere.<br />
<br />
En mi opinión, lo único negativo sobre la app es que esta enfocada a las apuestas deportivas y se ha dejado un poco
de lado al Casino.
</p>
<!----------------------------------------------------------------------------------------------------------------------------------------->
<div id="co-atencion-section" class="title-text opinion-card-title opinion-title-space linkable-section">
    Atención al cliente
</div>
<p class="opinion-p-space">
    El servicio al cliente nos parece bueno. Hay disponible un correo electrónico en donde los operadores se comprometen
    a responder con la mayor rapidez posible, un número de teléfono gratuito y un chat 24/7.<br />
    <br />
    • Correo: apuestas@codere.com<br />
    • Teléfono gratuito: 900 104 554<br />
    • Chat 24/7 en el footer de la web<br />
    <br />
    De cualquier forma, muchas de tus inquietudes y dudas podrán ser resueltas visitando el apartado de preguntas
    frecuentes que es muy completo.
</p>
<!----------------------------------------------------------------------------------------------------------------------------------------->
<div id="co-adicionales-section" class="title-text opinion-card-title opinion-title-space linkable-section">
    Características Adicionales
</div>
<div class="opinion-card-subtitle">
    Streaming
</div>
<p class="opinion-p-space">
    Codere ofrece un servicio de streaming para unos pocos partidos y esta disponible solamente para usuarios
    registrados. No importa si no tienes crédito en la cuenta solo hace falta demostrar que eres un usuario activo
    haciendo un depósito durante los últimos 30 días de calendario.
</p>
<div class="opinion-card-subtitle">
    Marcadores en vivo
</div>
<p class="opinion-p-space">
    Tienes una pagina de marcadores en directo para todas las modalidades deportivas. Puedes filtrar por fecha y
    deporte, así como marcar tus ligas favoritas. Esta funcionalidad esta disponible para todos, incluso sino estas
    registrado.
</p>
<div class="opinion-card-subtitle">
    Resultados y estadísticas
</div>
<p class="opinion-p-space">
    El apartado de estadísticas de Codere es bastante potente y está disponible para tanto usuarios registrados como no
    registrados.<br />
    <br />
    En esta sección podrás ver los números históricos de cualquier enfrentamiento deportivo. Tendrás a tu alcance los
    números de rendimiento, comparativas con otros años u otros enfrentamientos similares, tendencias, amonestaciones,
    información de los árbitros y mucho más.
</p>
<div id="co-opinion-section" class="title-text opinion-card-title opinion-title-space linkable-section">
    Mi opinión 
</div>
<p class="opinion-p-space">
    En mi opinión, Codere es una casa de apuesta deportiva sólida, que ofrece un bono transparente y sin demasiadas
    complicaciones. Con perfecta sinergia entre los locales físicos y la página web, permitiendo depositar y cobrar en
    locales sin problema alguno.<br />
    <br />
    Las cuotas para eventos deportivos de poca relevancia pueden mejorar. Sin embargo, hacen un gran trabajo con las
    ofertas de supercuotas para las competiciones principales.<br />
    <br />
    Codere es mas conocida como una casa de apuesta deportiva que como un casino online. No suelen dar mucho bombo a su
    sección casino, y la verdad es que le falta variedad, pero la selección esta bien curada. En cambio, la cobertura de
    apuestas deportivas es extensa.<br />
    <br />
    Lo cierto es que estamos ante una de las más punteras casas de apuesta de España, en donde las promociones son
    abundantes y la diversión esta asegurada.
</p>
`
}